import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import i18n from "i18next";
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as content from '../../utilities/content';

import TemplateSidebarRight from '../../templates/template-sidebar-right';
import ImgCover from '../../elements/img-cover';

const BlockNewestBooksSB = inject("stores") (
    observer (
        class BlockNewestBooksSB extends Component {

            constructor(props) {
                super(props);
                this.props = props;

                this.storeGeneral = this.props.stores.storeGeneral;
                this.storeUi = this.props.stores.storeUi;
                this.storeBooks = this.props.stores.storeBooks;
            }

            handleOnClick = (e, book) => {
                const sku = book.sku;
                const id = content.formatTitle(book.title);

                this.storeUi.setActiveSubCategory('');
                this.storeUi.setActiveCategory('');
                
                this.storeUi.setCurrentBook(sku);
              
                this.setState({
                    sku: sku
                });

                let url;
                if (parseInt(this.storeGeneral.settings_list.seoTitles) === 1) {
                    url = "/book/" + sku + "/" + id;
                } else {
                    url = "/book/" + sku;
                }
                this.props.history.push(url);
            }
 
            render() {
                return (
                    <div className="block--newest-books-sb">
                        <div className="block--newest-books-sb__block-title">
                            <h3>{this.props.block_title}<br />{this.props.block_subtitle}</h3>

                            {this.props.block_intro &&
                                <span className="block--newest-books-sb__intro">{i18n.t(this.props.block_intro)}</span>
                            }
                        </div> 
                        <div className="block--newest-books-sb__list">
                            <ul
                                className = "blocks__list blocks__list--covers-foldout --collapsed"
                            >
                                {this.storeBooks.bookList_newest.map((book, i) => (
                                    i < 6 && 
                                    <li 
                                    key={book.sku || `book-${i}`}
                                        className = "--link"
                                        onClick={(e) => this.handleOnClick(e, book)}
                                    >
                                            <div className="carousel--books__slide-content SB-own--books__slide-content">
                                            <ImgCover
                                                sku = {book.sku}
                                            />
                                            <span className="cover__tag">Eigen uitgave</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="block--newest-books-sb__link-all">
                            <Link to="our-publications">Bekijk alle eigen uitgaven</Link>
                        </div>
                    </div>
                )
            }
        }
    )
)

export default withTranslation()(withRouter(BlockNewestBooksSB));

